import * as React from "react";

// util
import { animated, useSpring } from "@react-spring/web";

export interface TeamHealthDashboardAnimProps {
  children: React.ReactNode;
}

export const TeamHealthDashboardAnim = ({ children }: TeamHealthDashboardAnimProps) => {
  const { textScale } = useSpring({
    from: { textScale: 0 },
    to: { textScale: 1 },
    config: { mass: 1, tension: 170, friction: 18, precision: 0.02 },
  });

  const scaleInterpolateRange = [0, 0.25, 0.35, 0.45, 0.5, 0.55, 0.65, 0.75, 1];
  const scaleInterpolateOutput = [1.04, 1.06, 1.07, 1.08, 1.1, 1.09, 1.08, 1.06, 1];

  return (
    <animated.div
      style={{
        transform: textScale
          .to({
            range: scaleInterpolateRange,
            output: scaleInterpolateOutput,
          })
          .to((x) => `scale(${x})`),
      }}
    >
      {children}
    </animated.div>
  );
};
